import React, { Component } from 'react'
import debounce from 'lodash/debounce'

const resizable = (WrappedComponent, wait = 0) =>
  class extends Component {
    state = {
      width: 0,
      height: 0,
      noPaddingWidth: 0,
      noPaddingHeight: 0,
      noBorderWidth: 0,
      noBorderHeight: 0,
      resizing: false,
    }
    constructor(...opts) {
      super(...opts)
      this.resizeHandler = wait
        ? debounce(this.resizeHandler.bind(this), wait, { leading: false, trailing: true })
        : this.resizeHandler.bind(this)
      this.onResize = this.onResize.bind(this)
    }

    onResize() {
      this.setState({ resizing: true }, this.resizeHandler)
    }

    resizeHandler() {
      if (this.component) {
        const style = getComputedStyle(this.component)
        const width = this.component.offsetWidth
        const height = this.component.offsetHeight
        const borderX = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth)
        const borderY = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth)
        const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
        const paddingY = parseFloat(style.paddingBottom) + parseFloat(style.paddingTop)
        const noPaddingWidth = width - borderX - paddingX
        const noPaddingHeight = width - borderY - paddingY
        const noBorderWidth = width - borderX
        const noBorderHeight = width - borderY
        this.setState({
          width,
          height,
          noPaddingWidth,
          noPaddingHeight,
          noBorderWidth,
          noBorderHeight,
          resizing: false,
        })
      }
    }
    componentDidMount() {
      this.onResize()
      window.addEventListener('resize', this.onResize)
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.onResize)
    }
    render() {
      return (
        <WrappedComponent
          {...this.props}
          resizeRef={c => {
            this.component = c
          }}
          {...this.state}
        />
      )
    }
  }

export default resizable
